import {
  FETCH_MODELS_LIST,
  RESET_MODELS_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {},
};

const modelsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MODELS_LIST:
      return { list: action.payload };
    case RESET_MODELS_LIST:
      return initialState;
    default:
      return state;
  }
};

export default modelsListReducer;
